export const environment = {
    clientId: 'c2ra39gepomdnhl56jh7gocfm',
    clientSecret: '15rcge2eaprq7n3t4gl5t3e4jqvhp909len5dtnbmfu7jcgpvph5',
    cognitoUrl: 'https://auth.sintrasjacol.org/login?client_id=c2ra39gepomdnhl56jh7gocfm&response_type=code&redirect_uri=https%3A%2F%2Fapp.sintrasjacol.org',
    tokenUrl: 'https://auth.sintrasjacol.org/oauth2/token',
    redirectUri: 'https://app.sintrasjacol.org',
    cognitoRevokeUrl: 'https://auth.sintrasjacol.org/oauth2/revoke',
    entityByDocumentUrl: 'https://api.sintrasjacol.org/entity',
    signersByEntityUrl: 'https://api.sintrasjacol.org/entity/signers',
    userUrl: 'https://api.sintrasjacol.org/user',
    documentByUserUrl: 'https://api.sintrasjacol.org/user/documents',
    signerUrl: 'https://api.sintrasjacol.org/signer',
    downLoadUrl: 'https://api.sintrasjacol.org/document',
    batchUrl: 'https://api.sintrasjacol.org/document/generate/batch',
    generateDocumentUrl: 'https://api.sintrasjacol.org/document/generate',
    saveFormUrl: 'https://api.sintrasjacol.org/form',
    modifyDocumentUrl: 'https://api.sintrasjacol.org/dataform',
    userInfoUrl: 'https://auth.sintrasjacol.org/oauth2/userInfo',
    templateDownloadUrl: '',
};
